import { USER_ROLES } from "@mj/shared-constants";

import { deployEnv } from "@/config/features";

export const SYSTEM_USERS: { fullName: string; email: string }[] = [
  {
    fullName: "Gavin Chambers",
    email: "gavin.chambers@mjevansconstruction.co.uk"
  },
  {
    fullName: "Tina Papadopoulou",
    email: "tina.papadopoulou@mjevansconstruction.co.uk"
  },
  {
    fullName: "Ashwini Sawant",
    email: "ashwini.sawant@mjevansconstruction.co.uk"
  },
  {
    fullName: "Krishna Sharma",
    email: "krishna.sharma-cis@mjevansconstruction.co.uk"
  },
  {
    fullName: "Jayan Shrestha",
    email: "jayan.shrestha@mjevansconstruction.co.uk"
  },
  {
    fullName: "Deenam Shahi",
    email: "deenam.shahi@mjevansconstruction.co.uk"
  },
  {
    fullName: "Prabhat Paudyal",
    email: "prabhat.paudyal@mjevansconstruction.co.uk"
  },
  {
    fullName: "Shikshya Shrestha",
    email: "shikshya.shrestha@mjevansconstruction.co.uk"
  },
  {
    fullName: "Ruan Shrestha",
    email: "ruan.shrestha@mjevansconstruction.co.uk"
  },
  {
    fullName: "Sugam Baskota",
    email: "sugam.baskota@mjevansconstruction.co.uk"
  },
  {
    fullName: "Akshay Shahi",
    email: "akshay.shahi@mjevansconstruction.co.uk"
  },
  {
    fullName: "Dave Coales",
    email: "dave.coales@mjevansconstruction.co.uk"
  },
  {
    fullName: "Cormac Flanagan",
    email: "cormac.flanagan@mjevansconstruction.co.uk"
  },
  {
    fullName: "Dean Duncan",
    email: "dean.duncan@mjevansconstruction.co.uk"
  },
  {
    fullName: "James Phillips",
    email: "james.phillips@mjevansconstruction.co.uk"
  },
  {
    fullName: "Adrian Norman",
    email: "adrian.norman@mjevansconstruction.co.uk"
  },
  {
    fullName: "Michael Brabazon",
    email: "michael.brabazon@mjevansconstruction.co.uk"
  },
  {
    fullName: "Tom Brabazon",
    email: "tom.brabazon@mjevansconstruction.co.uk"
  },
  {
    fullName: "Alex Paul",
    email: "alex.paul@mjevansconstruction.co.uk"
  },
  {
    fullName: "Adam Walker",
    email: "adam.walker@mjevansconstruction.co.uk"
  },
  {
    fullName: "Lee Kelly",
    email: "lee.kelly@mjevansconstruction.co.uk"
  },
  {
    fullName: "Mark Gouldings",
    email: "mark.gouldings@mjevansconstruction.co.uk"
  },
  {
    fullName: "Sam Tilley",
    email: "sam.tilley@mjevansconstruction.co.uk"
  },
  {
    fullName: "Ash Sammons",
    email: "ash.sammons@mjevansconstruction.co.uk"
  },
  {
    fullName: "Joe McPartlan",
    email: "joe.mcpartlan@mjevansconstruction.co.uk"
  },
  {
    fullName: "Andy Tomlinson",
    email: "andy.tomlinson@mjevansconstruction.co.uk"
  },
  {
    fullName: "Steve Wilson",
    email: "steve.wilson@mjevansconstruction.co.uk"
  },
  {
    fullName: "Andy Clifford",
    email: "andy.Clifford@mjevansconstruction.co.uk"
  },
  {
    fullName: "Chris Villers",
    email: "chris.Villers@mjevansconstruction.co.uk"
  },
  {
    fullName: "Alex Clack",
    email: "alex.Clack@mjevansconstruction.co.uk"
  },
  {
    fullName: "Joseph O'Neill",
    email: "Joseph.oneill@mjevansconstruction.co.uk"
  },
  {
    fullName: "Rob Hawthorne",
    email: "Rob.Hawthorne@mjevansconstruction.co.uk"
  },
  {
    fullName: "Rich Lewin",
    email: "Rich.Lewin@mjevansconstruction.co.uk"
  },
  {
    fullName: "Jack Randall",
    email: "Jack.Randall@mjevansconstruction.co.uk"
  },
  {
    fullName: "Stephen Slater",
    email: "Stephen.Slater@mjevansconstruction.co.uk"
  },
  {
    fullName: "Chris Hartley",
    email: "Chris.Hartley@mjevansconstruction.co.uk"
  },
  {
    fullName: "Michael Evans",
    email: "Michael.Evans@mjevansconstruction.co.uk"
  },
  {
    fullName: "Bradley Caseley",
    email: "Bradley.Caseley@mjevansconstruction.co.uk"
  },
  {
    fullName: "Joe Williams",
    email: "Joe.Williams@mjevansconstruction.co.uk"
  },
  {
    fullName: "Jon Burgwin",
    email: "Jon.Burgwin@mjevansconstruction.co.uk"
  },
  {
    fullName: "Louie Barley",
    email: "Louie.Barley@mjevansconstruction.co.uk"
  },
  {
    fullName: "Adrian Jarman",
    email: "Adrian.Jarman@mjevansconstruction.co.uk"
  },
  {
    fullName: "Oliver Read",
    email: "Oliver.read@mjevansconstruction.co.uk"
  },
  {
    fullName: "Sam Pinches",
    email: "Sam.Pinches@mjevansconstruction.co.uk"
  },
  {
    fullName: "Danny Walker",
    email: "Danny.Walker@mjevansconstruction.co.uk"
  },
  {
    fullName: "Michael Langhorn",
    email: "Michael.Langhorn@mjevansconstruction.co.uk"
  },
  {
    fullName: "Michael Maguire",
    email: "Michael.Maguire@mjevansconstruction.co.uk"
  },
  {
    fullName: "Shannon Kelly",
    email: "Shannon.Kelly@mjevansconstruction.co.uk"
  },
  {
    fullName: "Sanjay Mani",
    email: "Sanjay.Mani@mjevansconstruction.co.uk"
  },
  {
    fullName: "Ceri Harper",
    email: "Ceri.Harper@mjevansconstruction.co.uk"
  },
  {
    fullName: "Manjot Singh",
    email: "Manjot.Singh@mjevansconstruction.co.uk"
  },
  {
    fullName: "Shekhar Khatri",
    email: "shekhar.khatri2@mjevansconstruction.co.uk"
  },
  {
    fullName: "Andrew Dransfield",
    email: "Andrew.dransfield@mjevansconstruction.co.uk"
  },
  {
    fullName: "Apple App Tester",
    email: "AppleAppTester@mjevansconstruction.co.uk"
  },
  {
    fullName: "Elena Lascar",
    email: "Elena.Lascar@mjevansconstruction.co.uk"
  },
  {
    fullName: "Chris Gillen",
    email: "Chris.Gillen@mjevansconstruction.co.uk"
  },
  {
    fullName: "Judith Marriott",
    email: "Judith.Marriott@mjevansgroup.co.uk"
  },
  {
    fullName: "Alex Clack",
    email: "Alex.Clack@mjevansconstruction.co.uk"
  }
];

export { USER_ROLES };

/**
 * Roles that are not pinned to their own region: they can browse every
 * region from the region picker (Projects Dashboard) instead of being locked
 * to the region on their project-team record.
 */
const ALL_REGION_ROLES: readonly string[] = [
  USER_ROLES.BOARD_LEVEL,
  USER_ROLES.SYSTEM_ADMINISTRATOR
];

export const canViewAllRegions = (roleDisplayName?: string): boolean =>
  !!roleDisplayName && ALL_REGION_ROLES.includes(roleDisplayName);

export const isSystemAdministrator = (roleDisplayName?: string): boolean =>
  roleDisplayName === USER_ROLES.SYSTEM_ADMINISTRATOR;

/**
 * Project Team is System-Administrator-only everywhere except Dogma's own
 * DEV instance ("dogma qa"), where every role can access it so testers don't
 * need a System Administrator account.
 */
export const canAccessProjectTeamPage = (roleDisplayName?: string): boolean =>
  deployEnv === "dev" || isSystemAdministrator(roleDisplayName);
